function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { VueComponent } from '@progress/kendo-vue-common';
import Component from 'vue-class-component';
/**
 * @hidden
 */

var PagerNumericButtons =
/** @class */
function (_super) {
  __extends(PagerNumericButtons, _super);

  function PagerNumericButtons() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(PagerNumericButtons.prototype, "end", {
    get: function get() {
      return Math.min(this.start + this.$props.buttonCount - 1, this.$props.totalPages);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PagerNumericButtons.prototype, "start", {
    get: function get() {
      var page = this.$props.currentPage;
      var buttonCount = this.$props.buttonCount;

      if (page > buttonCount) {
        var reminder = page % buttonCount;
        return reminder === 0 ? page - buttonCount + 1 : page - reminder + 1;
      }

      return 1;
    },
    enumerable: true,
    configurable: true
  });

  PagerNumericButtons.prototype.click = function (e, page) {
    e.preventDefault();
    this.$props.pageChange(page, e);
  }; // @ts-ignore


  PagerNumericButtons.prototype.render = function (h) {
    var _this = this;

    var prevDots = this.start > 1 ? h("li", [h("a", {
      "class": "k-link",
      on: {
        "click": function click(e) {
          return _this.click(e, _this.start - 1);
        }
      },
      attrs: {
        href: "#"
      }
    }, ["..."])]) : '';
    var postDots = this.end < this.$props.totalPages ? h("li", [h("a", {
      "class": "k-link",
      on: {
        "click": function click(e) {
          return _this.click(e, _this.end + 1);
        }
      },
      attrs: {
        href: "#"
      }
    }, ["..."])]) : '';
    var buttons = [];

    for (var idx = this.start; idx <= this.end; idx++) {
      buttons.push(idx);
    }

    var numerics = buttons.map(function (page) {
      return h("li", {
        key: page
      }, [h("a", {
        attrs: {
          href: "#"
        },
        on: {
          "click": function click(e) {
            return _this.click(e, page);
          }
        },
        "class": _this.$props.currentPage === page ? 'k-link k-state-selected' : 'k-link'
      }, [page])]);
    });
    return h("ul", {
      "class": "k-pager-numbers k-reset"
    }, [prevDots, numerics, postDots]);
  };

  PagerNumericButtons = __decorate([Component({
    props: {
      buttonCount: Number,
      totalPages: Number,
      currentPage: Number,
      pageChange: Function
    }
  })], PagerNumericButtons);
  return PagerNumericButtons;
}(VueComponent);

export { PagerNumericButtons };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-vue-grid/dist/es/paging/PagerNumericButtons.js
// module id = null
// module chunks = 